import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => {

	return ( {
		dimmed: {
			color: theme.other.colors.text.secondary
		},
		bold: {
			fontWeight: 500
		},
		container: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center"

		},
		mainContainer: {
			display       : "flex",
			padding       : props?.isMobile ? undefined : "2rem",
			flexDirection : props?.isMobile ? "column" : "row",
			gap           : "1.5rem",
			maxWidth      : "1200px",
			alignItems    : "start",
			width         : "100%"

		},
		nameContainer: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "start",
			gap            : "1rem"
		},
		userPhoto: {
			borderRadius : "100%",
			width        : "5rem"

		},
		donateCard: {
			borderRadius : "1rem",
			border       : props?.isMobile ? undefined : `1px solid ${ theme.other.colors.border.primary }`,
			padding      : "2rem",
			flex         : "1",
			width        : "100%",
			minHeight    : "50vh"
		},
		input: {
			padding          : "2rem",
			borderWidth      : "2px",
			backgroundColor  : theme.other.colors.input.primary,
			"&::placeholder" : {
				color: theme.other.colors.text.secondary
			}
		},
		textInput: {
			padding         : "1rem",
			borderWidth     : "2px",
			backgroundColor : theme.other.colors.input.primary
		},
		formContainer: {
			display        : "flex",
			justifyContent : "center",
			flexDirection  : "column",
			gap            : "1.5rem"
		},
		rupee: {
			padding: "1rem"
		},
		rupeeContainer: {
			width: "4.5rem"
		},
		amountInput: {
			"&[data-with-icon]": {
				paddingLeft: "4.5rem"

			}
		},
		amountChipsContainer: {
			display  : "flex",
			gap      : "1rem",
			flexWrap : "wrap"
		},
		amountChip: {
			backgroundColor : theme.other.colors.input.primary,
			color           : theme.other.colors.text.secondary,
			borderRadius    : "1rem",
			height          : "2.5rem",
			// border          : `1px solid ${ theme.other.colors.border.primary }`,
			"&:hover"       : {
				backgroundColor: theme.other.colors.input.primary
			},
			"& span": {
				padding: "1rem"
			}

		},
		donateBtn: {
			margin: "2rem 0"
		},
		msgLabel: {
		},
		msgLabelContainer: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "space-between",
			gap            : "1rem",
			width          : "100%"

		},
		wordsLeft: {
			fontWeight : "normal",
			color      : theme.other.colors.text.secondary
		},
		bottomInfo: {
			display : "flex",
			gap     : "0.75rem"
		},
		historyContainer: {
			border       : props?.isMobile ? undefined : `1px solid ${ theme.other.colors.border.primary }`,
			borderRadius : props?.isMobile ? undefined : "1rem",
			overflow     : "hidden",
			flex         : "1",
			marginBottom : props?.isMobile ? "10rem" : undefined,
			minHeight    : theme.other.isMobile ? "60vh" : undefined,
			width        : "100%"
		},
		heading: {
			background : theme.other.colors.dialog.secondary,
			padding    : "2rem",
			display    : "flex",
			gap        : "1rem"

		},
		topDonors: {
			margin: "0"
		},
		userCardContainer: {
			display    : "flex",
			alignItems : "",
			minHeight  : "85px"
		},
		userLeft: {
			padding: "1rem 2rem"
		},
		userMiddle: {
			flex          : "1",
			padding       : "1rem",
			flexDirection : "column",
			alignItems    : "start",
			borderBottom  : `1px solid ${ theme.other.colors.border.primary }`
		},
		userRight: {
			padding      : "1rem",
			paddingRight : "2rem",
			borderBottom : `1px solid ${ theme.other.colors.border.primary }`
		},
		rowCenter: {
			display        : "flex",
			alignItems     : "center",
			justifyContent : "center"
		},
		emptyView: {
			minHeight     : "50vh",
			// minHeight     : props?.isMobile ? "40vh" : undefined,
			height        : "100%",
			flexDirection : "column",
			gap           : "2rem"
		},
		emptySvg: {
			opacity: "0.5"
		},
		message: {
			wordBreak: "break-word"
		},
		inputPlaceholder: {
		},
		donationBox: {
			display        : "flex",
			justifyContent : "center",
			gap            : "1rem",
			flexDirection  : "column"
		}
	} );
} );
